import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'

import { InputFieldComponent, InputFieldTheme } from '../input-field/input-field.component'
import { TextareaAutosizeDirective } from '../textarea-autosize.directive'
import { TranslatePipe } from '../translate.pipe'
import { ContactForm } from './contact.form'

@Component({
  selector: 'pai-contact-form',
  imports: [InputFieldComponent, TranslatePipe, ReactiveFormsModule, TextareaAutosizeDirective],
  templateUrl: './contact-form.component.html',
  styleUrl: './contact-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactFormComponent {
  readonly form = input.required<ContactForm>()
  readonly appearance = input.required<InputFieldTheme>()
}
